var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: this.groupId == 0 ? _vm.dialogTitleadd : _vm.dialogTitleedit,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "group_id" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("分组名称")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "group_id",
                      placeholder:
                        _vm.groupOptions.length > 0 ? "请选择" : "请先新建分组",
                      name: "groupName",
                      options: _vm.groupOptions,
                    },
                    model: {
                      value: _vm.ruleForm.group_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "group_id", $$v)
                      },
                      expression: "ruleForm.group_id",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }